import { Button } from "primereact/button";

const Botonera = ({ 
    rowData, 
    variant,
    isDinar,
    isSack,
    onVer,
    onMail, 
    onHistoria, 
    onRecotizar, 
    onFases, 
    onEditar,
    onDescartar,
    onFinalizar,
    onPublicar,
    onValidar
}) => {
    return ( 
        <div className="flex flex-column gap-2">
            <div className="flex gap-2 justify-content-start">

                {onVer && (<Button icon="pi pi-search" className="p-button-rounded p-button-info  p-button-sm" tooltip="Ver"tooltipOptions={{ position: 'top' }} aria-label="Ver" onClick={() => onVer(rowData)}/>)}
                {onMail && <Button tooltip="Mail" tooltipOptions={{ position: 'top' }} icon="pi pi-envelope" className="p-button-rounded p-button-info  p-button-sm" aria-label="Mail" onClick={() => onMail(rowData)}/>}
                {variant !== "NOTAVENTA" && onEditar && <Button tooltip="Editar" tooltipOptions={{ position: 'top' }} icon="pi pi-pencil" className="p-button-rounded p-button-primary  p-button-sm" aria-label="Editar" onClick={() => onEditar(rowData)} />}
                {variant !== "NOTAVENTA" && onPublicar && <Button tooltip="Publicar" tooltipOptions={{ position: 'top' }} icon="pi pi-flag" className="p-button-rounded p-button-primary  p-button-sm" aria-label="Publicar" onClick={() => onPublicar(rowData)}/>}
                {variant === "NOTAVENTA" && onValidar && <Button tooltip="Validar" tooltipOptions={{ position: 'top' }} icon="pi pi-check" className="p-button-rounded p-button-primary  p-button-sm" aria-label="Validar" onClick={() => onValidar(rowData)}/>}
            </div>
            <div className="flex gap-2 justify-content-start">
                {onHistoria && <Button tooltip="Historia" tooltipOptions={{ position: 'top' }} icon="pi pi-history" className="p-button-rounded p-button-info  p-button-sm" aria-label="Historia" onClick={() => onHistoria(rowData)} />}
                {onRecotizar && <Button tooltip="Recotizar" tooltipOptions={{ position: 'top' }} icon="pi pi-refresh" className="p-button-rounded p-button-primary  p-button-sm" aria-label="Recotizar" onClick={() => onRecotizar(rowData)}/>}
                {onFases && <Button tooltip="Fases" tooltipOptions={{ position: 'top' }} icon="pi pi-list" className="p-button-rounded p-button-info  p-button-sm" aria-label="Fases" onClick={() => onFases(rowData)}/>}
                {variant !== "NOTAVENTA" && onDescartar && <Button tooltip="Descartar" tooltipOptions={{ position: 'top' }} icon="pi pi-times" className="p-button-rounded p-button-primary  p-button-sm" aria-label="Descartar" onClick={() => onDescartar(rowData)} />}
                {isSack && onFinalizar && <Button tooltip="Finalizar" tooltipOptions={{ position: 'top' }} icon="pi pi-check" className="p-button-rounded p-button-primary  p-button-sm" aria-label="Finalizar" onClick={() => onFinalizar(rowData)} />}
            </div>
        </div>
        
    );
};

export default Botonera;
